import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/supplier_appCommonService";

const initialState = {
  pqList: {
    data: [],
    statusCounts: [],
    status: false,
    query: {
      page: 1,
      per_page: 10,
      searchTerm: "",
      status: "",
      email: "",
      pqVendorId: "",
      userId: "",
      referenceNumber: "",
      sortField: "createdAt",
      sortDirection: "desc",
    },
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  pqDetail: {
    data: {},
    status: false,
    pqVendorId: localStorage.getItem("pq_vendorId") || "",
  },
  pqSubmission: {
    data: {},
    status: false,
    referenceNumber: localStorage.getItem("pq_referenceNumber") || "",
    email: localStorage.getItem("pq_email") || "",
  },
  pqWorkflow: {
    workflow_record: null,
    logs: [],
    instanceId: "",
    status: false,
  },
};

const pqVendorSlice = createSlice({
  name: "pqVendor",
  initialState,
  reducers: {
    addPQVendorId: (state, action) => {
      state.pqDetail.pqVendorId = action.payload || "";
      localStorage.setItem("pq_vendorId", action.payload || "");
    },
    addPQSubmissionRef: (state, action) => {
      state.pqSubmission.referenceNumber = action.payload?.referenceNumber || "";
      state.pqSubmission.email = action.payload?.email || "";
      localStorage.setItem("pq_referenceNumber", action.payload?.referenceNumber || "");
      localStorage.setItem("pq_email", action.payload?.email || "");
    },
    setPQQuery: (state, action) => {
      state.pqList.query = { ...state.pqList.query, ...(action.payload || {}) };
    },
    resetPQWorkflow: (state) => {
      state.pqWorkflow.workflow_record = null;
      state.pqWorkflow.logs = [];
      state.pqWorkflow.instanceId = "";
      state.pqWorkflow.status = false;
    },
    clearPQData: (state) => {
      state.pqList.data = [];
      state.pqList.statusCounts = [];
      state.pqDetail.data = {};
      state.pqDetail.pqVendorId = "";
      state.pqSubmission.data = {};
      state.pqSubmission.referenceNumber = "";
      state.pqSubmission.email = "";
      localStorage.removeItem("pq_vendorId");
      localStorage.removeItem("pq_referenceNumber");
      localStorage.removeItem("pq_email");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPQVendorList.pending, (state) => {
        state.pqList.status = true;
      })
      .addCase(getPQVendorList.fulfilled, (state, action) => {
        state.pqList.status = false;
        state.pqList.data = action.payload?.data || [];
        state.pqList.statusCounts = action.payload?.statusCounts || [];
        state.pqList.pagination = {
          page: action.payload?.page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
        };
        if (action.meta?.arg) {
          state.pqList.query = { ...state.pqList.query, ...action.meta.arg };
        }
      })
      .addCase(getPQVendorList.rejected, (state) => {
        state.pqList.status = false;
      })

      .addCase(getPQVendorDetail.pending, (state) => {
        state.pqDetail.status = true;
      })
      .addCase(getPQVendorDetail.fulfilled, (state, action) => {
        state.pqDetail.status = false;
        const rows = action.payload?.data;
        state.pqDetail.data = Array.isArray(rows) ? rows[0] || {} : rows || {};
      })
      .addCase(getPQVendorDetail.rejected, (state) => {
        state.pqDetail.status = false;
      })

      .addCase(getPQSubmissionDetails.pending, (state) => {
        state.pqSubmission.status = true;
      })
      .addCase(getPQSubmissionDetails.fulfilled, (state, action) => {
        state.pqSubmission.status = false;
        state.pqSubmission.data = action.payload?.data || {};
      })
      .addCase(getPQSubmissionDetails.rejected, (state) => {
        state.pqSubmission.status = false;
      })

      .addCase(getPQWorkflowDetail.pending, (state) => {
        state.pqWorkflow.status = true;
      })
      .addCase(getPQWorkflowDetail.fulfilled, (state, action) => {
        state.pqWorkflow.status = false;
        state.pqWorkflow.workflow_record =
          action.payload?.data?.workflow_record || null;
        state.pqWorkflow.logs = action.payload?.data?.logs || [];
        state.pqWorkflow.instanceId = action.payload?.data?.instanceId || "";
      })
      .addCase(getPQWorkflowDetail.rejected, (state) => {
        state.pqWorkflow.status = false;
        state.pqWorkflow.workflow_record = null;
        state.pqWorkflow.logs = [];
      });
  },
});

export const {
  addPQVendorId,
  addPQSubmissionRef,
  setPQQuery,
  clearPQData,
  resetPQWorkflow,
} = pqVendorSlice.actions;
export default pqVendorSlice.reducer;

export const getPQVendorList = createAsyncThunk(
  "pqVendor/getPQVendorList",
  async (param) => {
    const response = await ItemService.getPQVendorList(param);
    return response;
  }
);

export const getPQVendorDetail = createAsyncThunk(
  "pqVendor/getPQVendorDetail",
  async (param) => {
    const response = await ItemService.getPQVendorDetail(param);
    return response;
  }
);

export const getPQSubmissionDetails = createAsyncThunk(
  "pqVendor/getPQSubmissionDetails",
  async (param) => {
    const response = await ItemService.getPQSubmissionDetails(param);
    return response;
  }
);

export const getPQWorkflowDetail = createAsyncThunk(
  "pqVendor/getPQWorkflowDetail",
  async (param) => {
    const response = await ItemService.getPQWorkflowDetail(param);
    return response;
  }
);
